<!--问答 QA-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">问答</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>

    <el-input
      v-if="operate === 'answer'"
      type="textarea"
      :autosize="{ minRows: 4 }"
      placeholder="请输入内容"
      resize="none"
      v-model="context"
      @blur="handleTextareaBlur"
    >
    </el-input>
    <div v-else class="select-view">
      <p style="font-size: 28rpx; color: #2b2f36; word-break: break-all">
        {{ answerText || "请输入" }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      answerText: "",
      context: "",
    };
  },
  methods: {
    handleTextareaBlur() {
      this.dataObj.context = this.context;
      this.answerObj = {
        question_id: this.dataObj.id,
        type: this.dataObj.type,
        if_hide: this.dataObj.if_hide,
        answer: [
          {
            id: "",
            context: this.context,
          },
        ],
      };
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          answer: this.answerObj,
          index: this.index,
        }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.context = this.dataObj.context;
        if (
          newVal.answer &&
          Array.isArray(newVal.answer.answer) &&
          newVal.answer.answer.length > 0
        ) {
          this.answerText = newVal.answer.answer[0].context || "";
        } else {
          this.answerText = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  height: 120px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewQA.vue